<template>
<div id="users-config-form-planning">
    <v-form ref="formUserConfigPlanningBO" v-model="validateUserForm">
        <v-row cols="12" class="row-form d-flex flex-column p-4">

            <div class="div-spans-title">
                <span class="span-laboral">{{$t('backoffice.modules-management.planning.form.productive-info')}}</span>
                <div class="switch-user text-end" style="width: 75%;">
                    <v-switch
                        v-model="userConfig.isActive"
                        :class="userConfig.isActive ? '' : 'custom-red'"
                        color="green"
                        :label="userConfig.isActive ? $t('backoffice.general.active-status') : $t('backoffice.general.inactive-status')"
                        hide-details
                        @change="onSwitchChange"
                    ></v-switch>
                </div>
                <div class="div-bottom-line"></div>
            </div>
            <v-col cols="12">
                <div class="d-flex" :class=" $vuetify.breakpoint.xsOnly ? 'flex-column' : 'col-divs-hour flex-row'">
                    <v-col cols="12" sm="3">
                        <v-text-field
                            v-model="userConfig.name"
                            :label="$t('backoffice.general.name-required')"
                            filled
                            :rules="formRules.defaultRules"
                        />
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-text-field
                            v-model="userConfig.secondName"
                            :label="$t('backoffice.general.last-name-required')"
                            filled
                            :rules="formRules.defaultRules"
                        />
                    </v-col>
                </div>
            </v-col>

            <div class="div-spans-title">
                <span class="span-laboral">{{$t('backoffice.general.garage')}}</span>
                <div class="div-bottom-line"></div>
            </div>
            <v-col cols="12">
                <div class="d-flex" :class=" $vuetify.breakpoint.xsOnly ? 'flex-column' : 'col-divs-hour flex-row'">
                    <v-col cols="12" sm="4">
                        <v-select
                            :label="$t('backoffice.modules-management.planning.form.available-garages-required')"
                            filled
                            v-model="userConfig.garageId"
                            :rules="formRules.defaultRules"
                            :items="dropGarages.map(el => ({text: el.name, value: el.garageID}))"
                            @change="$emit('on-change-garage', userConfig.garageId)"
                            :menu-props="{ top: false, offsetY: true }"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-dialog
                            ref="dialog"
                            v-model="allowableWasteOfTimeModal"
                            :return-value.sync="userConfig.wasteTime"
                            persistent
                            width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="userConfig.wasteTime"
                                :label="$t('backoffice.modules-management.planning.form.waste-time')"
                                append-icon="mdi-clock-time-four-outline"
                                readonly
                                filled
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                            </template>
                            <v-time-picker
                                v-if="allowableWasteOfTimeModal"
                                v-model="userConfig.wasteTime"
                                full-width
                                format="24hr"
                            >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="allowableWasteOfTimeModal = false"
                            >
                                {{$t('backoffice.actions.cancel')}}
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="$refs.dialog.save(userConfig.wasteTime)"
                            >
                                {{$t('backoffice.actions.ok')}}
                            </v-btn>
                            </v-time-picker>
                        </v-dialog>
                    </v-col>
                </div>
                <span class="subtitle-time">{{$t('backoffice.modules-management.planning.form.waste-time-subtitle')}}</span>
            </v-col>

            <!-- week days -->
            <div class="div-spans-title mt-4">
                <span class="span-laboral">{{$t('backoffice.modules-management.planning.form.labor-hour')}}</span>
                <p>{{$t('backoffice.modules-management.planning.form.edit-days-subtitle')}}</p>
                <div class="div-bottom-line">
                </div>
            </div>
            <div class="mt-2 default-garage-hours" v-if="userConfig.garageId">
                <span>{{$t('backoffice.modules-management.planning.form.garage-labor-hour')}}</span>
                <br>
                <span><b>{{$t('backoffice.modules-management.planning.form.garage-open')}}</b> {{transformHoursToShow('open', userConfig.garageId)}} - <b>{{$t('backoffice.modules-management.planning.form.garage-close')}}</b> {{transformHoursToShow('close', userConfig.garageId)}}</span>
                <br>
                <span><b>{{$t('backoffice.modules-management.planning.form.garage-lunch-start')}}</b> {{transformHoursToShow('lunchOpen', userConfig.garageId)}} - <b>{{$t('backoffice.modules-management.planning.form.garage-lunch-end')}}</b> {{transformHoursToShow('lunchClose', userConfig.garageId)}}</span>
            </div>
            <v-col cols="12">
                <v-row :class=" $vuetify.breakpoint.xsOnly ? 'flex-column' : 'flex-row'" style="width: 80%;">
                    <v-col sm="3" md="3" lg="2" v-for="(day, index) in userConfig.weekDays" :key="index">
                        <div class="d-flex flex-row">
                            <div class="d-flex flex-column">
                                <v-checkbox
                                    class="mr-4"
                                    v-model="day.value"
                                    :label="tanslateDayName(day.name)"
                                    color="primary"
                                    hide-details
                                    @click="onChangeWeekDayCheckbox(index, day.value)"
                                >
                                </v-checkbox>
                                <span class="span-hour-wd" v-if="day.value">{{$t('backoffice.modules-management.planning.form.initials-labor-hour')}} {{transformHoursToShow(day.workStartHourID)}} - {{transformHoursToShow(day.workEndHourID)}}</span>
                                <span class="span-hour-wd" v-if="day.value && day.hasLunchTime">{{$t('backoffice.modules-management.planning.form.initials-lunch-time')}} {{transformHoursToShow(day.lunchStartHourID)}} - {{transformHoursToShow(day.lunchEndHourID)}}</span>
                            </div>
                            <span class="mr-2 p-0 circle-span-edit" @click="onEditDays(index)">
                                <img src="/images/_SVGs/bo/edit_pencil.svg" class="circle" onload="SVGInject(this)" width="12" height="12" />
                            </span>
                        </div>
                    </v-col>
                </v-row>
            </v-col>

            <div class="div-spans-title mt-4">
                <span class="span-laboral">{{$t('backoffice.modules-management.planning.form.productive-color')}}</span>
                <div class="div-bottom-line"></div>
            </div>
            <v-col cols="12" class="mt-2">
                <v-color-picker
                    dot-size="25"
                    swatches-max-height="200"
                    mode="hexa"
                    v-model="userConfig.color"
                    :value="userConfig.color"
                ></v-color-picker>
            </v-col>

            <div class="div-spans-title mt-1">
                <span class="span-laboral">{{$t('backoffice.modules-management.planning.form.absence-management')}}</span>
                <div class="div-bottom-line"></div>
            </div>
            <v-col cols="12">
                 <v-row
                    v-for="(absences, index) in userConfig.planningsUsersAbsences"
                    :key="index"
                    cols="12"
                    class="d-flex"
                    :class="$vuetify.breakpoint.xsOnly ? 'flex-column' : 'flex-row'"
                >
                    <v-col cols="12" sm="3" md="3" lg="2">
                        <v-text-field
                            :label="$t('backoffice.modules-management.planning.form.reason-required')"
                            filled
                            v-model="absences.absenceDescription"
                            :rules="formRules.defaultRules"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="2">
                        <v-menu
                            :ref="'dialogStartDate' + absences.planningUserAbsenceId"
                            v-model="absences.dialogTimeStartDate"
                            :close-on-content-click="false"
                            :return-value.sync="absences.startDate"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="absences.startDate"
                                :label="$t('backoffice.modules-management.planning.form.start-date-required')"
                                append-icon="mdi-calendar"
                                readonly
                                filled
                                :rules="formRules.defaultRules"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="absences.startDate"
                                scrollable
                            >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="absences.dialogTimeStartDate = false"
                            >
                                {{$t('backoffice.actions.cancel')}}
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="saveAbsencesStartDate(absences)"
                            >
                                {{$t('backoffice.actions.ok')}}
                            </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="2">
                        <v-select
                            :label="$t('backoffice.modules-management.planning.form.start-hour')"
                            filled
                            v-model="absences.startHourID"
                            :items="hourLaborDrops.map(el => ({text: el.hour, value: el.calendarHoursId}))"
                            :menu-props="{ top: false, offsetY: true }"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="2">
                        <v-menu
                            :ref="'dialogEndDate' + absences.planningUserAbsenceId"
                            v-model="absences.dialogTimeEndDate"
                            :close-on-content-click="false"
                            :return-value.sync="absences.endDate"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="absences.endDate"
                                :label="$t('backoffice.modules-management.planning.form.end-date')"
                                append-icon="mdi-calendar"
                                readonly
                                filled
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="absences.endDate"
                                scrollable
                            >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="absences.dialogTimeEndDate = false"
                            >
                                {{$t('backoffice.actions.cancel')}}
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="saveAbsencesEndDate(absences)"
                            >
                                {{$t('backoffice.actions.ok')}}
                            </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="2">
                        <v-select
                            :label="$t('backoffice.modules-management.planning.form.end-hour')"
                            filled
                            v-model="absences.endHourID"
                            :items="hourLaborDrops.map(el => ({text: el.hour, value: el.calendarHoursId}))"
                            :menu-props="{ top: false, offsetY: true }"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="2" class="d-flex flex-column" :class="$vuetify.breakpoint.xsOnly ? 'text-center' : ''">
                        <div class="flex-row">
                            <span @click="onDeleteAbsences(index)">
                                <img
                                    src="/images/_SVGs/bo/remove.svg"
                                    class="circle mt-4"
                                    onload="SVGInject(this)"
                                    width="12"
                                    height="12"
                                />
                            </span>
                        </div>
                    </v-col>
                    <hr v-if="$vuetify.breakpoint.xsOnly" />
                </v-row>
                <div class="mt-4" :class="$vuetify.breakpoint.xsOnly ? 'text-center' : 'text-start'">
                    <v-btn
                        fab
                        dark
                        x-small
                        color="var(--v-primary-base)"
                        @click="onClickToCreateAbsences"
                    >
                        <v-icon dark>
                            mdi-plus
                        </v-icon>
                    </v-btn>
                    <span @click="onClickToCreateAbsences" class="ml-4 span-add-extra-service">{{$t('backoffice.modules-management.planning.form.create-absence')}}</span>
                </div>
            </v-col>
        </v-row>
    </v-form>

    <base-modal v-model="modalCreateAbsence.show" :title="$t('backoffice.modules-management.planning.form.add-absence')" modal-width="500px" modalAlign="align__flex--center" @watch-show-value="clickOutsideModalAbs">
        <template v-slot:modal-body>
            <v-form v-model="modalCreateAbsence.validationAbsence">
                    <v-col cols="12" class="p-0">
                        <v-text-field
                            :label="$t('backoffice.modules-management.planning.form.reason-required')"
                            filled
                            v-model="modalCreateAbsence.absence.absenceDescription"
                            :rules="formRules.defaultRules"
                        ></v-text-field>
                    </v-col>
                    <v-row class="d-flex row">
                        <v-col cols="12" sm="6">
                            <v-menu
                                ref="menuNewAbsStartDate"
                                v-model="modalCreateAbsence.absence.dialogTimeStartDate"
                                :close-on-content-click="false"
                                :return-value.sync="modalCreateAbsence.absence.startDate"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="modalCreateAbsence.absence.startDate"
                                    :label="$t('backoffice.modules-management.planning.form.start-date')"
                                    append-icon="mdi-calendar"
                                    readonly
                                    filled
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="modalCreateAbsence.absence.startDate"
                                    scrollable
                                >
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="modalCreateAbsence.absence.dialogTimeStartDate = false"
                                >
                                    {{$t('backoffice.actions.cancel')}}
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.menuNewAbsStartDate.save(modalCreateAbsence.absence.startDate)"
                                >
                                    {{$t('backoffice.actions.ok')}}
                                </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-menu
                                ref="newAbsMenuEndDate"
                                v-model="modalCreateAbsence.absence.dialogTimeEndDate"
                                :close-on-content-click="false"
                                :return-value.sync="modalCreateAbsence.absence.endDate"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="modalCreateAbsence.absence.endDate"
                                    :label="$t('backoffice.modules-management.planning.form.end-date')"
                                    append-icon="mdi-calendar"
                                    readonly
                                    filled
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="modalCreateAbsence.absence.endDate"
                                    scrollable
                                    :min="modalCreateAbsence.absence.startDate"
                                >
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="modalCreateAbsence.absence.dialogTimeEndDate = false"
                                >
                                    {{$t('backoffice.actions.cancel')}}
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.newAbsMenuEndDate.save(modalCreateAbsence.absence.endDate)"
                                >
                                    {{$t('backoffice.actions.ok')}}
                                </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row class="d-flex row">
                        <v-col cols="12" sm="6">
                            <v-select
                                :label="$t('backoffice.modules-management.planning.form.start-hour')"
                                filled
                                v-model="modalCreateAbsence.absence.startHourID"
                                :items="hourLaborDrops.map(el => ({text: el.hour, value: el.calendarHoursId}))"
                                :menu-props="{ top: false, offsetY: true }"
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-select
                                :label="$t('backoffice.modules-management.planning.form.end-hour')"
                                filled
                                v-model="modalCreateAbsence.absence.endHourID"
                                :items="hourLaborDrops.map(el => ({text: el.hour, value: el.calendarHoursId}))"
                                :menu-props="{ top: false, offsetY: true }"
                            ></v-select>
                        </v-col>
                    </v-row>
            </v-form>
        </template>

        <template v-slot:modal-actions>
            <v-btn style="text-transform: capitalize" class="danger-button" text @click="onCancelAbsence">
                {{$t('backoffice.actions.cancel')}}
            </v-btn>
            <v-btn :disabled="!modalCreateAbsence.validationAbsence" style="text-transform: capitalize" class="primary-button" text @click="onConfirmCreateAbsence">
                {{$t('backoffice.actions.ok')}}
            </v-btn>
        </template>
    </base-modal>

    <base-modal v-model="modalEditWeekDay.show" :title="`${$t('backoffice.modules-management.planning.form.labor-hour-of')} ${tanslateDayName(modalEditWeekDay.weekDayNew.name)}`" modal-width="480px" modalAlign="align__flex--center" @watch-show-value="clickOutsideModalWD">
            <template v-slot:modal-body>
                <v-form v-model="modalEditWeekDay.validationWeekDayForm">
                    <v-row class="d-flex" :class="$vuetify.breakpoint.xsOnly ? 'flex-column' : 'flex-row'">
                        <v-col sm="6">
                            <v-select
                                :label="$t('backoffice.modules-management.planning.form.start-open-hour-required')"
                                filled
                                v-model="modalEditWeekDay.weekDayNew.workStartHourID"
                                :items="hourLaborDrops.map(el => ({text: el.hour, value: el.calendarHoursId}))"
                                :rules="[startHourRulesForm]"
                                :menu-props="{ top: false, offsetY: true }"
                            ></v-select>
                        </v-col>
                        <v-col sm="6">
                            <v-select
                                ref="refCloseHour"
                                :label="$t('backoffice.modules-management.planning.form.end-close-hour-required')"
                                filled
                                v-model="modalEditWeekDay.weekDayNew.workEndHourID"
                                :items="hourLaborDrops.map(el => ({text: el.hour, value: el.calendarHoursId}))"
                                :rules="[closeHourRulesForm]"
                                :menu-props="{ top: false, offsetY: true }"
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row class="d-flex" :class="$vuetify.breakpoint.xsOnly ? 'flex-column' : 'flex-row'">
                        <v-col sm="6">
                            <v-select
                                ref="refLunchStart"
                                :label="$t('backoffice.modules-management.planning.form.start-lunch-time-required')"
                                filled
                                v-model="modalEditWeekDay.weekDayNew.lunchStartHourID"
                                :items="hourLaborDrops.map(el => ({text: el.hour, value: el.calendarHoursId}))"
                                :rules="modalEditWeekDay.weekDayNew.hasLunchTime ? [startLunchHourRulesForm(modalEditWeekDay.weekDayNew.lunchStartHourID, modalEditWeekDay.weekDayNew.workEndHourID, modalEditWeekDay.weekDayNew.workStartHourID)] : []"
                                :disabled="!modalEditWeekDay.weekDayNew.hasLunchTime"
                                :menu-props="{ top: false, offsetY: true }"
                            ></v-select>
                        </v-col>
                        <v-col sm="6">
                            <v-select
                                ref="refLunchEnd"
                                :label="$t('backoffice.modules-management.planning.form.end-lunch-time-required')"
                                filled
                                v-model="modalEditWeekDay.weekDayNew.lunchEndHourID"
                                :items="hourLaborDrops.map(el => ({text: el.hour, value: el.calendarHoursId}))"
                                :rules="modalEditWeekDay.weekDayNew.hasLunchTime ? [endLunchHourRulesForm(modalEditWeekDay.weekDayNew.lunchEndHourID, modalEditWeekDay.weekDayNew.lunchStartHourID, modalEditWeekDay.weekDayNew.workEndHourID, modalEditWeekDay.weekDayNew.workStartHourID)] : []"
                                :disabled="!modalEditWeekDay.weekDayNew.hasLunchTime"
                                :menu-props="{ top: false, offsetY: true }"
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-col cols="12" class="pt-0 pl-0">
                        <v-switch v-model="modalEditWeekDay.weekDayNew.hasLunchTime" :label="$t('backoffice.modules-management.planning.form.has-lunch-time')"></v-switch>
                    </v-col>
                </v-form>
            </template>

            <template v-slot:modal-actions>
                <v-btn style="text-transform: capitalize" class="danger-button" text @click="onCancelEditWeekDay">
                    {{$t('backoffice.actions.cancel')}}
                </v-btn>
                <v-btn :disabled="!modalEditWeekDay.validationWeekDayForm" style="text-transform: capitalize" class="primary-button" text @click="onConfirmWeekDay">
                    {{$t('backoffice.actions.record')}}
                </v-btn>
            </template>
    </base-modal>

</div>
</template>

<script>

import {isEmail, required} from "@src/utils/validations.js";
import {GenericServicesGetCalendarHoursDrop} from '@services/GenericServices';
import BaseModal from "@components/shared/widgets/BaseModal.vue";

export default {
    components: {BaseModal},

    props: {
        userConfig: Array | Object,
        dropGarages: Array,
        isCreate: Boolean, default: false,
    },

    data() {
        return {
            validateUserForm: false,
            formRules: { defaultRules: [required], emailRules: [v => v.length === 0 || isEmail(v) || this.$t('backoffice.rules.invalid-email')], },
            garagesDrops: [{text: 'Oficina Teste', value: 1}, {text: 'Maia', value: 2}],
            allowableWasteOfTimeModal: false,
            hourLaborDrops: [{"calendarHoursId":1,"hour":"08:00"},{"calendarHoursId":11,"hour":"08:30"},{"calendarHoursId":2,"hour":"09:00"},{"calendarHoursId":12,"hour":"09:30"},{"calendarHoursId":3,"hour":"10:00"},{"calendarHoursId":13,"hour":"10:30"},{"calendarHoursId":4,"hour":"11:00"},{"calendarHoursId":14,"hour":"11:30"},{"calendarHoursId":5,"hour":"12:00"},{"calendarHoursId":15,"hour":"12:30"},{"calendarHoursId":6,"hour":"13:00"},{"calendarHoursId":16,"hour":"13:30"},{"calendarHoursId":7,"hour":"14:00"},{"calendarHoursId":17,"hour":"14:30"},{"calendarHoursId":8,"hour":"15:00"},{"calendarHoursId":18,"hour":"15:30"},{"calendarHoursId":9,"hour":"16:00"},{"calendarHoursId":19,"hour":"16:30"},{"calendarHoursId":10,"hour":"17:00"},{"calendarHoursId":20,"hour":"17:30"},{"calendarHoursId":21,"hour":"18:00"},{"calendarHoursId":22,"hour":"18:30"},{"calendarHoursId":23,"hour":"19:00"},{"calendarHoursId":24,"hour":"19:30"},{"calendarHoursId":25,"hour":"20:00"},{"calendarHoursId":26,"hour":"20:30"},{"calendarHoursId":27,"hour":"21:00"},{"calendarHoursId":28,"hour":"21:30"},{"calendarHoursId":29,"hour":"22:00"}],
            modalCreateAbsence: {
                show: false,
                validationAbsence: false,
                absence: {
                    absenceDescription: '',
                    planningUserAbsenceId: '',
                    startDate: new Date().toISOString().substr(0, 10),
                    endDate: null,
                    startHourID: 0,
                    endHourID: 0,
                    dialogTimeStartDate: false,
                    dialogTimeEndDate: false,
                },
            },
            modalEditWeekDay: {
                show: false,
                validationWeekDayForm: false,
                weekDayOld: null,
                weekDayNew: { name: '', value: true, workStartHourID: 1, workEndHourID: 21, lunchStartHourID: 6, lunchEndHourID: 7, planningUserCalendarHourWeekDayId: null, isDisabled: false, hasLunchTime: true },
            }
        }
    },

    watch: {
        validateUserForm: {
            handler: function(newValue, oldValue) {
                this.$emit('on-change-validate-form', newValue);
            },
            deep: true,
            immediate: true
        },
        userConfig: {
            handler: function(newValue) {
                return newValue;
            },
            deep: true,
            immediate: true
        }
    },

    methods: {
        startHourRulesForm(value) {
            let transformOpen = this.findHourStringFromId(value);
            const findGarage = this.dropGarages.find(g => g.garageID == this.userConfig.garageId);
            if(findGarage) {
                let findOpenHourString = this.hourLaborDrops.find(e => e.calendarHoursId == findGarage.openHourId);
                let findCloseHourString = this.hourLaborDrops.find(e => e.calendarHoursId == findGarage.closeHourId);
                if(findOpenHourString && transformOpen < findOpenHourString.hour) {
                    return this.$t('backoffice.modules-management.planning.form.rules.higher-hour')
                } else if(findCloseHourString && transformOpen > findCloseHourString.hour) {
                    return this.$t('backoffice.modules-management.planning.form.rules.less-hour')
                } else {
                    return !!value || this.$t('backoffice.modules-management.planning.form.rules.required-field');
                }
            } else {
                return !!value || this.$t('backoffice.modules-management.planning.form.rules.required-field');
            }
        },

        closeHourRules(value) {
            let transformClose = this.findHourStringFromId(value);
            let transformOpen = this.findHourStringFromId(this.userConfig.workStartHourId);
            transformClose = this.transformHours(transformClose);
            transformOpen = this.transformHours(transformOpen);

            // First transform hours on date js
            // let timeStart = new Date(transformOpen).getHours();
            // let timeEnd = new Date(transformClose).getHours();
            // Pick diff hours start
            // let hoursDiff = timeEnd - timeStart;

            // First transform hours on date js milliseconds
            let timeStart =  new Date(transformOpen).getTime();
            let timeEnd =  new Date(transformClose).getTime();

            // Pick diff hours start
            let hoursDiff = timeEnd - timeStart;

            if(hoursDiff < -1 || hoursDiff == 0) {
                return this.$t('backoffice.modules-management.planning.form.rules.higher-entrance-hour')
            } else {
                return !!value || this.$t('backoffice.modules-management.planning.form.rules.required-field')
            }
        },

        startLunchHourRules(value) {
            let transformClose = this.findHourStringFromId(this.userConfig.workEndHourId);
            let transformOpen = this.findHourStringFromId(this.userConfig.workStartHourId);
            let startLunchHour = this.findHourStringFromId(value);
            transformClose = this.transformHours(transformClose);
            transformOpen = this.transformHours(transformOpen);
            startLunchHour = this.transformHours(startLunchHour);

            // First transform hours on date js
            // let timeStart = new Date(transformOpen).getHours();
            // let timeEnd = new Date(transformClose).getHours();
            // let timeStartLunch = new Date(startLunchHour).getHours();

            // Pick diff hours start
            // let hoursDiffClose = timeStartLunch - timeEnd;
            // let hoursDiffOpen = timeStartLunch - timeStart;

            // First transform hours on date js milliseconds
            let timeStart =  new Date(transformOpen).getTime();
            let timeEnd =  new Date(transformClose).getTime();
            let timeStartLunch = new Date(startLunchHour).getTime();

            // Pick diff hours start
            let hoursDiffClose = timeStartLunch - timeEnd;
            let hoursDiffOpen = timeStartLunch - timeStart;

            if(this.$refs.endLunchHourSelect) {
                this.$refs.endLunchHourSelect.validate();
            }

            if(hoursDiffClose >= 0) {
                return this.$t('backoffice.modules-management.planning.form.rules.less-close-hour')
            }
            if(hoursDiffOpen <= 0) {
                return this.$t('backoffice.modules-management.planning.form.rules.higher-entrance-hour')
            } else {
                return !!value || this.$t('backoffice.modules-management.planning.form.rules.required-field');
            }
        },

        endLunchHourRules(value) {
            let transformClose = this.findHourStringFromId(this.userConfig.workEndHourId);
            let transformOpen = this.findHourStringFromId(this.userConfig.workStartHourId);
            let startLunchHour = this.findHourStringFromId(this.userConfig.lunchStartHourId);
            let endLunchHour = this.findHourStringFromId(value);
            transformClose = this.transformHours(transformClose);
            transformOpen = this.transformHours(transformOpen);
            startLunchHour = this.transformHours(startLunchHour);
            endLunchHour = this.transformHours(endLunchHour);

            // First transform hours on date js
            // let timeStart = new Date(transformOpen).getHours();
            // let timeEnd = new Date(transformClose).getHours();
            // let timeStartLunch = new Date(startLunchHour).getHours();
            // let timeEndLunch = new Date(endLunchHour).getHours();

            //Pick diff hours start
            // let hoursDiffClose = timeEndLunch - timeEnd;
            // let hoursDiffOpen = timeEndLunch - timeStart;
            // let hoursDiffLunch = timeEndLunch - timeStartLunch;

            // First transform hours on date js milliseconds
            let timeStart =  new Date(transformOpen).getTime();
            let timeEnd =  new Date(transformClose).getTime();
            let timeStartLunch = new Date(startLunchHour).getTime();
            let timeEndLunch = new Date(endLunchHour).getTime();

            // Pick diff hours start
            let hoursDiffClose = timeStartLunch - timeEnd;
            let hoursDiffOpen = timeStartLunch - timeStart;
            let hoursDiffLunch = timeEndLunch - timeStartLunch;

            if(hoursDiffClose >= 0 || timeEndLunch >= timeEnd ) {
                 return this.$t('backoffice.modules-management.planning.form.rules.less-close-hour')
            }
            if(hoursDiffOpen <= 0) {
                return this.$t('backoffice.modules-management.planning.form.rules.higher-entrance-hour')
            }
            if(hoursDiffLunch <= 0) {
                return this.$t('backoffice.modules-management.planning.form.rules.higher-lunch-time')
            } else {
                return !!value || this.$t('backoffice.modules-management.planning.form.rules.required-field');
            }
        },

        transformHours(hour) {
            let today = new Date().toISOString();
            today = today.split("T");
            return today[0] + 'T' + hour + ':00' + '.0000';
        },

        findHourStringFromId(hourId) {
            let hourString = this.hourLaborDrops.filter(e => e.calendarHoursId == hourId);
            if(hourString && hourString.length > 0) {
                return hourString[0].hour;
            } else {
                return '';
            }
        },

        transformHoursToShow(hourId, garageId) {

            if(garageId) {
                const findGarage = this.dropGarages.find(g => g.garageID == garageId);
                if(findGarage) {
                    if(hourId == 'open') {
                        let findHourString = this.hourLaborDrops.find(e => e.calendarHoursId == findGarage.openHourId);
                        if(!findHourString) return this.$t('backoffice.general.no-info');
                        return findHourString.hour;
                    } else if (hourId == 'close') {
                        let findHourString = this.hourLaborDrops.find(e => e.calendarHoursId == findGarage.closeHourId);
                        if(!findHourString) return this.$t('backoffice.general.no-info');
                        return findHourString.hour;
                    } else if (hourId == 'lunchOpen') {
                        let findHourString = this.hourLaborDrops.find(e => e.calendarHoursId == findGarage.startLunchHourId);
                        if(!findHourString) return this.$t('backoffice.general.no-info');
                        return findHourString.hour;
                    } else if(hourId == 'lunchClose') {
                        let findHourString = this.hourLaborDrops.find(e => e.calendarHoursId == findGarage.endLunchHourId);
                        if(!findHourString) return this.$t('backoffice.general.no-info');
                        return findHourString.hour;
                    }
                } else {
                    return this.$t('backoffice.general.no-info')
                }
            }

            let findHourString = this.hourLaborDrops.filter(e => e.calendarHoursId == hourId);
            if(findHourString && findHourString.length > 0) {
                return findHourString[0].hour;
            } else {
                return ''
            }

        },

        tanslateDayName(dayName) {
            switch (dayName) {
                case 'Sunday':
                    return this.$t('backoffice.general.sunday');
                    break;
                case 'Monday':
                    return this.$t('backoffice.general.monday');
                    break;
                case 'Tuesday':
                    return this.$t('backoffice.general.tuesday');
                    break;
                case 'Wednesday':
                    return this.$t('backoffice.general.wednesday');
                    break;
                case 'Thursday':
                    return this.$t('backoffice.general.thursday');
                    break;
                case 'Friday':
                    return this.$t('backoffice.general.friday');
                    break;
                case 'Saturday':
                    return this.$t('backoffice.general.saturday');
                    break;
                default:
                    `${dayName}`;
            }
        },

        onEditDays(dayIndex) {
            const day = this.userConfig.weekDays[dayIndex];
            this.modalEditWeekDay.show = true;
            this.modalEditWeekDay.weekDayOld = _.cloneDeep(day);
            this.modalEditWeekDay.weekDayNew = _.cloneDeep(day);
        },

        onCancelEditWeekDay() {
            this.modalEditWeekDay.show = false;
            this.modalEditWeekDay.weekDayOld = null;
            this.modalEditWeekDay.weekDayNew = { name: '', value: true, workStartHourID: 1, workEndHourID: 21, lunchStartHourID: 6, lunchEndHourID: 7, planningUserCalendarHourWeekDayId: null, isDisabled: false, hasLunchTime: true };
        },

        onConfirmWeekDay() {
            this.modalEditWeekDay.show = false;
            let newDay = _.cloneDeep(this.modalEditWeekDay.weekDayNew);
            newDay.value = true;
            newDay.isDisabled = false;
            this.$emit('on-edit-days', newDay);
        },

        onClickToCreateAbsences() {
            this.modalCreateAbsence.show = true;
        },

        onCancelAbsence() {
            this.modalCreateAbsence = {
                show: false,
                validationAbsence: false,
                absence: {
                    absenceDescription: '',
                    planningUserAbsenceId: '',
                    startDate: new Date().toISOString().substr(0, 10),
                    endDate: null,
                    startHourID: 0,
                    endHourID: 0,
                    dialogTimeStartDate: false,
                    dialogTimeEndDate: false,
                },
            }
        },

        onConfirmCreateAbsence() {
            let newAbs = _.cloneDeep(this.modalCreateAbsence.absence);
            newAbs.planningUserAbsenceId = this.userConfig.planningsUsersAbsences.length > 0 ? _.last(this.userConfig.planningsUsersAbsences).planningUserAbsenceId + 1 : 1,
            this.$emit('on-create-absences', newAbs);
            this.modalCreateAbsence = {
                show: false,
                validationAbsence: false,
                absence: {
                    absenceDescription: '',
                    planningUserAbsenceId: '',
                    startDate: new Date().toISOString().substr(0, 10),
                    endDate: null,
                    startHourID: 0,
                    endHourID: 0,
                    dialogTimeStartDate: false,
                    dialogTimeEndDate: false,
                },
            }
        },

        onDeleteAbsences(absencesIndex) {
            const absence = this.userConfig.planningsUsersAbsences[absencesIndex];
            this.$emit('on-delete-absences', absence, absencesIndex);
        },

        saveAbsencesStartDate(absences) {
            const absencesRef = 'dialogStartDate' + absences.planningUserAbsenceId;
            this.$refs[absencesRef][0].save(absences.startDate);
        },

        saveAbsencesEndDate(absences) {
            const absencesRef = 'dialogEndDate' + absences.planningUserAbsenceId;
            this.$refs[absencesRef][0].save(absences.endDate);
        },

        closeHourRulesForm(value) {
            let stringHourClose = this.hourLaborDrops.filter(e => e.calendarHoursId == value);
            let stringHourOpen = this.hourLaborDrops.filter(e => e.calendarHoursId == this.modalEditWeekDay.weekDayNew.workStartHourID);
            const findGarage = this.dropGarages.find(g => g.garageID == this.userConfig.garageId);
            let findCloseHourString = null;
            if(findGarage) {
                findCloseHourString = this.hourLaborDrops.find(e => e.calendarHoursId == findGarage.closeHourId);
            }

            if(this.$refs.refLunchStart) {
                this.$refs.refLunchStart.focus();
                this.$refs.refLunchEnd.focus();

                if(this.$refs.refCloseHour) {
                    this.$refs.refCloseHour.blur();

                    setTimeout(() => {
                        this.$refs.refLunchStart.blur();
                        this.$refs.refLunchEnd.blur();
                    }, 500)
                }

            }

            if(stringHourClose.length > 0 && stringHourOpen.length > 0) {
                const transformClose = this.transformHoursWeekDaysForm(stringHourClose[0].hour);
                const transformOpen = this.transformHoursWeekDaysForm(stringHourOpen[0].hour);

                // First transform hours on date js
                let timeStart = new Date(transformOpen).getHours();
                let timeEnd = new Date(transformClose).getHours();

                //Pick diff hours start
                let hoursDiff = timeEnd - timeStart;
                if(transformClose <= transformOpen) {
                    return this.$t('backoffice.modules-management.planning.form.rules.higher-entrance-hour')
                } else if(findGarage && findCloseHourString && stringHourClose[0].hour > findCloseHourString.hour) {
                    return this.$t('backoffice.modules-management.planning.form.rules.less-exit-hour')
                } else {
                    return !!value || this.$t('backoffice.modules-management.planning.form.rules.required-field');
                }
            } else {
                return !!value || this.$t('backoffice.modules-management.planning.form.rules.required-field');
            }
        },

        startLunchHourRulesForm(lunchStart, close, open) {
            let closeString = this.hourLaborDrops.filter(e => e.calendarHoursId == close);
            let openString = this.hourLaborDrops.filter(e => e.calendarHoursId == open);
            let startLunchString = this.hourLaborDrops.filter(e => e.calendarHoursId == lunchStart);

            if(closeString.length > 0 && openString.length > 0 && startLunchString.length > 0) {

                const transformClose = this.transformHoursWeekDaysForm(closeString[0].hour);
                const transformOpen = this.transformHoursWeekDaysForm(openString[0].hour);
                const startLunchHour = this.transformHoursWeekDaysForm(startLunchString[0].hour);

                // First transform hours on date js
                let timeStart = new Date(transformOpen).getHours();
                let timeEnd = new Date(transformClose).getHours();
                let timeStartLunch = new Date(startLunchHour).getHours();

                //Pick diff hours start
                let hoursDiffClose = timeStartLunch - timeEnd;
                let hoursDiffOpen = timeStartLunch - timeStart;

                if(startLunchHour >= transformClose) {
                    return this.$t('backoffice.modules-management.planning.form.rules.less-close-hour')
                }
                if(startLunchHour <= transformOpen) {
                    return this.$t('backoffice.modules-management.planning.form.rules.higher-entrance-hour')
                } else {
                    return !!lunchStart || this.$t('backoffice.modules-management.planning.form.rules.required-field');
                }
            } else {
                return !!lunchStart || this.$t('backoffice.modules-management.planning.form.rules.required-field');
            }
        },

        endLunchHourRulesForm(lunchEnd, lunchStart, close, open) {
            let closeString = this.hourLaborDrops.filter(e => e.calendarHoursId == close);
            let openString = this.hourLaborDrops.filter(e => e.calendarHoursId == open);
            let startLunchString = this.hourLaborDrops.filter(e => e.calendarHoursId == lunchStart);
            let endLunchString = this.hourLaborDrops.filter(e => e.calendarHoursId == lunchEnd);

            if(closeString.length > 0 && openString.length > 0 && startLunchString.length > 0 && endLunchString.length > 0) {
                const transformClose = this.transformHoursWeekDaysForm(closeString[0].hour);
                const transformOpen = this.transformHoursWeekDaysForm(openString[0].hour);
                const startLunchHour = this.transformHoursWeekDaysForm(startLunchString[0].hour);
                const endLunchHour = this.transformHoursWeekDaysForm(endLunchString[0].hour, closeString[0].hour, openString[0].hour);

                // First transform hours on date js
                let timeStart = new Date(transformOpen).getHours();
                let timeEnd = new Date(transformClose).getHours();
                let timeStartLunch = new Date(startLunchHour).getHours();
                let timeEndLunch = new Date(endLunchHour).getHours();

                //Pick diff hours start
                let hoursDiffClose = timeEndLunch - timeEnd;
                let hoursDiffOpen = timeEndLunch - timeStart;
                let hoursDiffLunch = timeEndLunch - timeStartLunch;

                if(hoursDiffClose >= 0) {
                    return this.$t('backoffice.modules-management.planning.form.rules.less-close-hour')
                }
                if(hoursDiffOpen <= 0) {
                    return this.$t('backoffice.modules-management.planning.form.rules.higher-entrance-hour')
                }
                if(endLunchHour <= startLunchHour) {
                    return this.$t('backoffice.modules-management.planning.form.rules.higher-lunch-time')
                } else {
                    return !!lunchEnd || this.$t('backoffice.modules-management.planning.form.rules.required-field');
                }
            } else {
                return !!lunchEnd || this.$t('backoffice.modules-management.planning.form.rules.required-field');
            }

        },

        transformHoursWeekDaysForm(hour) {
            let today = new Date().toISOString();
            today = today.split("T");
            return today[0] + 'T' + hour + ':00' + '.0000';
        },

        onGetCalendarHours() {
            return GenericServicesGetCalendarHoursDrop()
            .then(response => {
                this.hourLaborDrops = response.data.result;
                this.$store.commit('backofficeCalendarHoursDropdown/setCalendarHoursDropdowns', this.hourLaborDrops);
            })
            .catch(error => {
                console.error('error to get scheduling calendar hours', error);
            })
            .finally(() => {

            })
        },

        onChangeWeekDayCheckbox(index, dayValue) {
            this.$emit('on-change-weekday-checkbox', index, dayValue);
            this.$emit('on-change-validate-form', this.validateUserForm);
        },

        onSwitchChange() {
            this.$emit('on-change-validate-form', this.validateUserForm);
        },

        clickOutsideModalAbs(value) {
            if(!value) {
                this.onCancelAbsence();
            }
        },

        clickOutsideModalWD(value) {
            if(!value) {
                this.onCancelEditWeekDay();
            }
        },

    },

    mounted() {
        this.onGetCalendarHours();
    }
}
</script>

<style lang="scss" scoped>
@import "@sass/_variables.scss";
#users-config-form-planning {
    .valueRange{
        font-size: 12px;
        margin-left: 15px;
    }
    .div-spans-title {
        width: 100%;
            .div-bottom-line {
                border-bottom: 1px solid $grey-border-tab;
                width: 75%;
                border-bottom-width: 1px;
                margin-top: 9px;
                @media(max-width: 501px) {
                    width: 100%;
                }
            }
        .span-laboral {
            margin-bottom: -15px;
            font-size: 18px;
            font-weight: bold;
        }
    }

    .col-divs-hour {
        margin-bottom: -30px;
        margin-left: -10px;
    }

    .circle-span-edit {
        background-color: #E6E5E5;
        width: 20px;
        height: 0px;
        border-radius: 50%;
        display: -webkit-inline-box;
        cursor: pointer;
        margin-bottom: 6px;
        margin-top: 22px;
    }

    ::v-deep .v-label {
        margin-top: 5px;
    }

    .span-add-extra-service {
        color: var(--v-primary-base);
        cursor: pointer;
    }

    .btn-blue {
        text-transform: capitalize;
    }

    .span-hour-wd {
        margin-left: 3px;
        text-align: left;
        font: normal normal normal 10px/15px Lato;
        letter-spacing: 0px;
        color: #9E9D9D;
        opacity: 1;
    }

    .subtitle-time {
        font-size: 10px;
    }

    ::v-deep .switch-user{
        .v-input--switch__track:not(.green--text) {
            color: var(--v-error-lighten1) !important;
        }
        .v-input--switch__thumb:not(.green--text) {
            color: var(--v-error-base) !important;
        }
    }

    .switch-user {
        @media(min-width: 501px) {
            width: 75%;
            justify-content: flex-end;
            display: flex;
            position: absolute;
            margin-top: -48px;
            margin-left: -70px;
        }
    }

    .default-garage-hours {
        p, span {
            font-size: 12px;
        }
    }
}
</style>
